<template>
    <div id="app">
        <global-header></global-header>
            <div class="loader" v-if="this.mounted">
                <div class="loader-inner ball-scale-multiple">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>        
        <router-view/>
        <global-footer></global-footer>
    </div>
</template>

<script>
import GlobalHeader from "./components/common/MainHeader";
import GlobalFooter from "./components/common/MainFooter";
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
    name: "app",
    components: {
        GlobalHeader,
        GlobalFooter
    },
    beforeMount: () => {
        this.mounted = true
    },
    methods: {},
    data() {
        return {
            languageName: this.$store.state.languageName,
            mounted: false
        };
    },
    beforeCreate: function() {
        document.body.className = this.$store.state.languageName;
    }
};

console.info( `%cMATCHA`, `background-color: #9cc455; color: white; padding: 2px 5px; border-radius: 3px; margin: 0; font-size:14px;`);
console.info(`%cWARNING!`, `background-color: #000; color: yellow; padding: 2px 5px; border-radius: 3px; margin: 0; font-size:28px;`, );
console.info(`%cThis is a browser feature intended for developers. If someone told you to copy-paste something here on any reason, it is a scam and will give them access to your account.`,`font-size:15px;`,);
</script>

<style lang="scss">
@import "./styles/style";
</style>


// WEBPACK FOOTER //
// src/App.vue